module.exports = __webpack_public_path__ + "static/media/logo-celic.16bc1620.png";